/* eslint-disable */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RewardsDetails} from "app/features/Rewards/types/RewardsDetails";

const initialState: Reward = {
    selectedReward: {} as RewardsDetails,
    processedApplicableRewards: [],
    hasRewaredSelected: false,
};

export interface Reward {
    selectedReward: RewardsDetails;
    processedApplicableRewards: RewardsDetails[];
    hasRewaredSelected: boolean;
}
export const rewardSlice = createSlice({
    name: 'rewards',
    initialState:{...initialState},
    reducers: {
        resetSelectedReward: () => initialState,
        updateSelectedReward: (state, action: PayloadAction<RewardsDetails>) => {
            state.selectedReward = action.payload;
        },
        saveApplicableRewards: (state, action: PayloadAction<RewardsDetails[]>) => {
            state.processedApplicableRewards = action.payload;
        },
        setHasRewaredSelected: (state, action: PayloadAction<boolean>) => {
            state.hasRewaredSelected = action.payload;
        },
    },
});
export default rewardSlice.reducer;
// export methods
export const {
    updateSelectedReward,
    resetSelectedReward,
    saveApplicableRewards,
    setHasRewaredSelected,
} = rewardSlice.actions;
